var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 417,
    viewBox: "0 0 336 417",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34-29.5C4 42-29.7 211.3 75.5 316.5 180.7 421.7 324 419.333 382.5 405",
    stroke: "#FF8A8A",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.35,
    strokeDasharray: "0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBg2);
export default __webpack_public_path__ + "static/media/imgBg2.34601ac827237f267952a0be14ef180e.svg";
export { ForwardRef as ReactComponent };